import { render, staticRenderFns } from "./SwipeCardStack.vue?vue&type=template&id=7aa34db4&"
import script from "./SwipeCardStack.vue?vue&type=script&lang=js&"
export * from "./SwipeCardStack.vue?vue&type=script&lang=js&"
import style0 from "./SwipeCardStack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports